import React, { memo } from 'react';

import { useThemeGetter } from '@hooks';

import { EThemesEnum } from '@enum';

import lbg from '@assets/images/light-background.jpg';
import dbg from '@assets/images/dark-background.jpg';

import { BGContainer, BGIMG } from './WoodBackground.styled';

export const WoodBackground = memo(() => {
  const { type } = useThemeGetter();

  const imageChanger = (themeType: EThemesEnum) => {
    switch (themeType) {
      case EThemesEnum.dark:
        return dbg;
      default:
        return lbg;
    }
  };

  return (
    <BGContainer>
      <BGIMG src={imageChanger(type)} alt="bg" />
    </BGContainer>
  );
});
